import { Component, inject } from '@angular/core';
import { FeatureService } from '../shared/services/feature.service';
import { ErrorMessageService } from '../shared/services/error-message.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-error',
  standalone: false,
  templateUrl: './error.html',
  styleUrl: './error.scss'
})
export class Error {
  private readonly featureService = inject(FeatureService);
  private readonly errorMessageService = inject(ErrorMessageService);
  protected readonly showDetails = !environment.production;

  get errorDetails(): string | null {
    return this.featureService.errorDetails;
  }

  get isExpired(): boolean {
    return this.featureService.errorKind === 'expired';
  }

  get expiredMessage(): string {
    return this.errorMessageService.getExpiredMessage(this.featureService.errorUserMessage);
  }

  get genericMessage(): string {
    return this.featureService.errorUserMessage || 'Sorry, something went wrong.';
  }
}
